import {ConfiguratorStateService} from '../../../Services/ListConfiguration/configurator-state.service';
import { MatTableModule } from '@angular/material/table';
import {NgForOf, NgStyle} from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import {Subscription} from 'rxjs';
import { COMPANY_INFO_COLUMN_MAP, COLUMN_PATTERN_GENERATORS } from '../InfoConverstion'

@Component({
  selector: 'app-listpreview',
  standalone: true,
  imports: [
    MatTableModule,
    NgForOf,
    NgStyle,
  ],
  templateUrl: './listpreview.component.html',
  styleUrl: './listpreview.component.scss'
})
export class ListpreviewComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = [];
  dataSource: any[] = [];
  private sub: Subscription;

  constructor(public configState: ConfiguratorStateService) {}

  ngOnInit() {
    this.sub = this.configState.selectedCompanyInfos$.subscribe(cols => {
      this.displayedColumns = [
        'Name',
        ...cols
            .map(label => COMPANY_INFO_COLUMN_MAP[label] || [label])
            .flat()
      ];
      this.dataSource = this.generateMockData(this.displayedColumns, 10);
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }


  generateMockData(columnNames: string[], rowCount: number): any[] {
    return Array.from({ length: rowCount }, (_, i) => {
      const row: any = {};
      for (const col of columnNames) {
        // Pick a pattern function if available, or fallback to a generic value
        row[col] = COLUMN_PATTERN_GENERATORS[col]
            ? COLUMN_PATTERN_GENERATORS[col](i)
            : `Value ${i + 1}`;
      }
      return row;
    });
  }

}